import {CursorType, DiagramActionType, DiagramModeType} from '@/enums/diagrams';
import {DiagramMode} from '@/interfaces/diagrams';
/*
Списки режимов диаграмм по типу
*/

export const signalDiagramModes: DiagramMode[] = [
  {
    id: DiagramActionType.FindPeaks,
    icon: 'triangle',
    name: 'Показать максимумы',
    isMenu: true,
    menuAlterName: 'Скрыть максимумы',
    type: DiagramModeType.Action,
    compatibleModeIds: [
      'view',
      CursorType.Cursor,
      CursorType.MarkerCursor,
      CursorType.ModulationCursor,
    ],
    canLiveUpdate: false,
    isSync: false,
  },

  {
    id: 'view',
    icon: 'magnify',
    name: 'Просмотр',
    isMenu: true,
    menuAlterName: 'Отключить просмотр',
    type: DiagramModeType.View,
    compatibleModeIds: [
      DiagramActionType.FindPeaks,
      CursorType.Cursor,
      CursorType.MarkerCursor,
      CursorType.ModulationCursor,
    ],
    canLiveUpdate: true,
    isSync: true,
  },
  {
    id: CursorType.Cursor,
    icon: 'cursor-text',
    name: 'Курсор',
    type: DiagramModeType.Cursor,
    compatibleModeIds: [DiagramActionType.FindPeaks],
    canLiveUpdate: false,
    isSync: true,
  },
  {
    id: CursorType.MarkerCursor,
    icon: 'arrow-expand-horizontal',
    name: 'Маркер',
    type: DiagramModeType.Cursor,
    compatibleModeIds: [DiagramActionType.FindPeaks],
    canLiveUpdate: false,
    isSync: true,
  },
  {
    id: CursorType.ModulationCursor,
    icon: 'arrow-collapse-horizontal',
    name: 'Модуляционный курсор',
    type: DiagramModeType.Cursor,
    compatibleModeIds: [DiagramActionType.FindPeaks],
    canLiveUpdate: false,
    isSync: true,
  },
];

export const spectrumDiagramModes: DiagramMode[] = [
  {
    id: DiagramActionType.FindPeaks,
    icon: 'triangle',
    name: 'Показать максимумы',
    isMenu: true,
    menuAlterName: 'Скрыть максимумы',
    type: DiagramModeType.Action,
    compatibleModeIds: [
      'view',
      CursorType.Cursor,
      CursorType.MarkerCursor,
      CursorType.ModulationCursor,
      CursorType.HarmonicCursor,
      CursorType.SubHarmonicCursor,
    ],
    canLiveUpdate: false,
    isSync: false,
  },
  {
    id: 'view',
    icon: 'magnify',
    name: 'Просмотр',
    isMenu: true,
    menuAlterName: 'Отключить просмотр',
    type: DiagramModeType.View,
    compatibleModeIds: [
      DiagramActionType.FindPeaks,
      CursorType.Cursor,
      CursorType.MarkerCursor,
      CursorType.ModulationCursor,
      CursorType.HarmonicCursor,
      CursorType.SubHarmonicCursor,
    ],
    canLiveUpdate: true,
    isSync: true,
  },
  {
    id: CursorType.Cursor,
    icon: 'cursor-text',
    name: 'Курсор',
    type: DiagramModeType.Cursor,
    compatibleModeIds: [DiagramActionType.FindPeaks],
    canLiveUpdate: false,
    isSync: true,
  },
  {
    id: CursorType.MarkerCursor,
    icon: 'arrow-expand-horizontal',
    name: 'Маркер',
    type: DiagramModeType.Cursor,
    compatibleModeIds: [DiagramActionType.FindPeaks],
    canLiveUpdate: false,
    isSync: true,
  },
  {
    id: CursorType.ModulationCursor,
    icon: 'arrow-collapse-horizontal',
    name: 'Модуляционный курсор',
    type: DiagramModeType.Cursor,
    compatibleModeIds: [DiagramActionType.FindPeaks],
    canLiveUpdate: false,
    isSync: true,
  },
  {
    id: CursorType.HarmonicCursor,
    icon: 'sort-variant',
    degreeRotateIcon: 270,
    name: 'Гармонический курсор',
    type: DiagramModeType.Cursor,
    compatibleModeIds: [DiagramActionType.FindPeaks, CursorType.SubHarmonicCursor],
    canLiveUpdate: false,
    isSync: true,
  },
  {
    id: CursorType.SubHarmonicCursor,
    icon: 'sort-reverse-variant',
    degreeRotateIcon: 270,
    name: 'Субгармонический курсор',
    type: DiagramModeType.Cursor,
    compatibleModeIds: [DiagramActionType.FindPeaks, CursorType.HarmonicCursor],
    canLiveUpdate: false,
    isSync: true,
  },
];

export const vibrationDiagramModes: DiagramMode[] = [
  {
    id: 'view',
    icon: 'magnify',
    name: 'Просмотр',
    isMenu: true,
    menuAlterName: 'Отключить просмотр',
    type: DiagramModeType.View,
    compatibleModeIds: [CursorType.Cursor],
    canLiveUpdate: false,
    isSync: true,
  },
  {
    id: CursorType.Cursor,
    icon: 'cursor-text',
    name: 'Курсор',
    type: DiagramModeType.Cursor,
    compatibleModeIds: [],
    canLiveUpdate: false,
    isSync: true,
  },
];
